import { render, staticRenderFns } from "./RegisterPrincipal.vue?vue&type=template&id=fbbb67b8&scoped=true"
import script from "./RegisterPrincipal.vue?vue&type=script&lang=js"
export * from "./RegisterPrincipal.vue?vue&type=script&lang=js"
import style0 from "./RegisterPrincipal.vue?vue&type=style&index=0&id=fbbb67b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbb67b8",
  null
  
)

export default component.exports